import actionTypes from "../actionTypes";

export function requestDailyBonus() {
  return {
    type: actionTypes.DAILY_BONUS_REQUEST
  };
}

export function successDailyBonus() {
  return {
    type: actionTypes.DAILY_BONUS_SUCCESS
  };
}